<template>
    <div id="delivery-date-modal" class="modal fade" role="dialog"  data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-md">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">{{ form.is_pickup == 1 ? trans('step1.choose_your_fitting_date','Choose Your Fitting Date'): trans('step1.choose_your_delivery_date','Choose Your Delivery Date') }}</h4>
                </div>
                <div class="modal-body">
                    <form method="POST" @submit.prevent="saveDeliveryData">
                        <div class="row">
                            <div class="text-center">
                                <delivery-date-picker/>
                                <p v-if="!form.delivery_date && form_submitted" class="text-danger">{{trans('step1.plz_select_delivery_date','Please Select Delivery Date.')}}</p>
                            </div>
                        </div>
                        <div class="row m-t-20">
                            <div class="col-sm-6">
                                <delivery-time-picker/>
                                <p v-if="!form.delivery_time && form_submitted" class="text-danger">{{trans('step1.plz_select_delivery_time','Please Select Delivery Time.')}}</p>
                            </div>
                            <div class="col-sm-6" v-if="form.delivery_date && form.delivery_time">
                                <div class="form-group">
                                    <label for="first-day-skiing">{{trans('step1.first_ski_date','First Ski Date')}}</label>
                                    <input type="text" class="form-control" :value="form.first_day_skiing" id="first-day-skiing"  name="first-day-skiing" disabled v-if="form.delivery_time">
                                    <input type="text" class="form-control" id="first-day-skiing2" name="first-day-skiing" disabled v-else>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-9">
                                <p class="h6">{{form.is_pickup == 1 ?trans('step1.charged_fitting_description','Fitting after '+ cut_of_time +' will not be charged for a rental day',cut_of_time):trans('step1.charged_delivery_description','Deliveries after '+ cut_of_time +' will not be charged for a rental day',cut_of_time)}}</p>
                            </div>

                            <div class="col-sm-2">
                                <button id="delivery-modal-next-button" type="submit" class="btn btn-blue btn-cart-md">{{ fromDetailBar ? trans('general.save','Save') : trans('general.Next','Next') }}</button>
                            </div>
                        </div>

                    </form>
                    <div class="overlay-loader" v-if="isLoading">
                        <i class="overlay-img-load"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from "vuex";
import DeliveryDatePicker from "../DeliveryDatePicker";
import DeliveryTimePicker from "../DeliveryTimePicker";
export default {
    props: {'fromDetailBar': false},
    name: 'DeliveryDateModal',
    components: {DeliveryDatePicker, DeliveryTimePicker},
    computed:{
        ...mapState(['form', 'isLoading', 'cut_of_time']),
    },
    data(){
        return {
            'form_submitted' : false,
        }
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        saveDeliveryData() {
            this.form_submitted = true;

            this.$store.dispatch('clearDeliveryTimeIfWrong')


            if (this.form.delivery_date && this.form.delivery_time) {
                $('.close').click();
                $('#delivery-date-modal').on('hidden.bs.modal', function (e) {
                    $('#return-date-modal').modal('toggle');
                })
            }else{

                //focus on field
                let ele = document.getElementById('delivery-modal-time-picker');
                if(ele){
                    this.cursorFocus(ele, 'start')
                }
            }
        },

        cursorFocus(elem, block='end') {
            elem.focus();
            elem.scrollIntoView({behavior: "smooth", block: block});
        },
    }
}
</script>
